export default class Event {
    constructor(Rest) {
        this.rest = Rest.rest;
    }

    allByStatus(status, page) {
        page = page || 1;
        return this.rest.one('event').get({ status: status, page: page });
    };

    find(id) {
        return this.rest.one('event', id).get();
    };

    create(name) {
        return this.rest.all('event').post({name: name});
    };

    remove(id) {
        return this.rest.one('event', id).remove();
    };

    update(event) {
        return this.rest.one('event', event.id).customPUT(event);
    };

    statusCounts() {
        return this.rest.one('event').one('statusCounts').get();
    };

    saveMetadata(event) {
        return this.rest.all('event/metaData').post({ event: event });
    };

    getCustomEventSettings() {
        return this.rest.one('event').one('eventTemplateSettings').get();
    };

    fetchEventTemplatesByTopic(eventId) {
        return this.rest.one('event', eventId).one('fetchTemplatesByTopic').get();
    };

    generateMessages(eventId) {
        return this.rest.all('event/generateMessages').post({ id: eventId });
    };

    getParsedInvitationContent(eventId) {
        return this.rest.one('event', eventId).one('parseInvitation').get();
    };

    savePage(eventId, pageType, data) {
        return this.rest.all('event/saveEventPage').post({eventId: eventId, pageType: pageType, data: data });
    };

    removeDispatcher(eventId, dispatcherType, dispatcherId) {
        return this.rest.one('event', eventId).one('dispatcher', dispatcherId).one(dispatcherType).remove();
    };

    addDispatcher(eventId, type) {
        return this.rest.all('event/addDispatcher').post({ eventId: eventId, type: type });
    };

    setEdited(dispatcherId, type) {
        return this.rest.all('event/setEdited').post({ dispatcherId: dispatcherId, type: type });
    };

    addInvitations(eventId, to) {
        return this.rest.all('event/addInvitations').post({ eventId: eventId, to: to });
    };

    resendInvitations(eventId) {
        return this.rest.all(`event/resendInvitations/${eventId}`).post();
    };

    publishPage(eventId, pageType) {
        return this.rest.all('event/publishPage').post({ eventId: eventId, pageType: pageType });
    };

    previewPage(eventId, pageType) {
        return this.rest.all('event/previewPage').post({ eventId: eventId, pageType: pageType });
    };

    getFlowStatistics(eventId) {
        return this.rest.one('event', eventId).one('flowStatistics').get();
    };

    findCustomGroup(eventId) {
        return this.rest.one('event', eventId).one('find-custom-group').get();
    };

    getSurveyedSubscribers(eventId) {
        return this.rest.one('event', eventId).one('getSurveyedSubscribers').get();
    };

    cancel(eventId, cancellationText) {
        return this.rest.all('event/cancel').post({ id: eventId, text: cancellationText });
    };

    setCancellationRecipients(eventId, toAttenders) {
        return this.rest.all('event/cancellationRecipients').post({ id: eventId, toAttenders: toAttenders });
    };

    searchByStatus(status, search) {
        return this.rest.one('event', status).one('search').get({ search: search });
    };

    unsubscribe(eventId, subscriberId) {
        return this.rest.one('event', eventId).one('unsubscribe', subscriberId).get();
    };
}

Event.$inject = ['Rest'];
